module.exports = __webpack_public_path__ + "static/media/twoSlidingInstallGuide.0a690b75.png";